import {
  createSlice,
  createSelector,
  createAsyncThunk,
  createEntityAdapter
} from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { API_PATH } from '../../constants';
import { Inject } from '../../Classes1';
import _ from 'lodash';
import { http } from '../../utils/config';

const playerInjectAdapter = createEntityAdapter()

const initialState = playerInjectAdapter.getInitialState()

// Thunk functions
export const fetchInjects = createAsyncThunk('inject/fetchInjects', async (scenarioId: string, { rejectWithValue } ) => {
  try {
    
    const response = await http.get(API_PATH + "/scenario/" + scenarioId + "/injects")
    return response;
  } catch (error: any) {
    if (error.response && error.response.data.message) {
      return rejectWithValue(error.response.data.message)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

const playerInjectSlice = createSlice({
    name: 'injects',
    initialState,
    reducers: {
      injectToggled(state, action) {
        //const injectId = action.payload
      },
    },
  /*extraReducers: (builder) => {
    builder
      .addCase(fetchInjects.fulfilled, (state, action) => {
        playerInjectAdapter.setAll(state, action.payload)
      })
  }*/
})

export const {
  injectToggled
} = playerInjectSlice.actions

export default playerInjectSlice.reducer

export const {
  selectAll: selectInjects
} = playerInjectAdapter.getSelectors((state: RootState) => state.playerInjects)

export const createInject = createAsyncThunk(
  'injects/createInject',
  async (scenario1: any, { rejectWithValue }) => {
    try {

      const response = await http.put(API_PATH + '/scenario/'+scenario1.scenarioId+'/injects', { injects: scenario1.injects });
      return response.data
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const selectInjects1 = createSelector(
  selectInjects,
  (injectResponse: any[]) => { 
    if (_.isEmpty(injectResponse)) {
      return [];
    } else {
      return injectResponse[0].map((inject: Inject) => {
        return inject;
      })
    }
  }
)
